import React from 'react';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Close';
import InputMask from 'react-input-mask';
import moment from 'moment';
import cs from 'classnames';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import { makeStyles } from '@material-ui/core/styles';
import FilledInput from '@material-ui/core/FilledInput';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';


import Input from '../../Input';
import { Context } from '../../../context';
import * as actions from '../../../actions';
import { DefaultButton as Button } from '../../Button';

const Ordering = ({ classes, orderingDataSave, changeStep, changeOrderingDataSave }) => {
  const { state: { insurance }, dispatch } = React.useContext(Context);
  const [orderingData, onChange] = React.useState({ firstName: '', lastName: '', middleName: '', birthday: null });
  const [editInsure, editItem] = React.useState({ firstName: '', lastName: '', middleName: '', birthday: null });

  React.useEffect(() => {
    if (orderingDataSave) {
      saveCurrentOrderingData()
    }
  }, [orderingDataSave]);



  const deletItem = id => () => {
    actions.updateInsurance({
      id: insurance.id,
      delete: {
        insurersIds: [id],
      },
    }, dispatch)
  }

  const saveCurrentOrderingData = () => {
    if (orderingData.firstName && orderingData.lastName) {
      actions.updateInsurance({
        id: insurance.id,
        add: {
          insurers: [{
            ...orderingData,
            birthday: moment(orderingData.birthday, 'DD-MM-YYYY').utc(true).toISOString()
          }],
        },
      }, dispatch)
      changeStep(2)
    }
    changeOrderingDataSave(false)
    if (insurance.insurers.length) {
      changeStep(2)
    }
  }

  const onAddPeople = () => {
    if (orderingData.firstName && orderingData.lastName && orderingData.birthday) {
      actions.updateInsurance({
        id: insurance.id,
        add: {
          insurers: [{
            ...orderingData,
            birthday: moment(orderingData.birthday, 'DD-MM-YYYY').utc(true).toISOString()
          }],
        },
      }, dispatch)
      onChange({ firstName: '', lastName: '', birthday: '', middleName: '' })
    }
  }

  const handleChangeInput = name => ({ target: { value } }) => {
    const newData = JSON.parse(JSON.stringify(orderingData));
    newData[name] = value;
    onChange(newData);
  }

  const handleChangeDate = name => ({ target: { value } }) => {
    const newData = JSON.parse(JSON.stringify(orderingData));
    let splitedDate = value.split('-');
    if (value.length > 7) {
      const mm = Number(splitedDate[1]) > 12 ? 12 : splitedDate[1];
      splitedDate[1] = mm;
      const mmDays = moment(`01-${mm}`, 'DD-MM').daysInMonth();
      if (Number(splitedDate[0]) > mmDays) {
        splitedDate[0] = mmDays
      }
      if (Number(splitedDate[2]) > moment().get('years')) {
        splitedDate[2] = moment().get('years')
      }
    }
    newData[name] = splitedDate.join('-');
    onChange(newData);
  }

  const onEditInsure = insure => () => {
    editItem({
      ...insure,
      birthday: moment(insure.birthday).format('DD-MM-YYYY')
    })
  }

  const onSaveInsure = () => {
    actions.updateInsurance({
      id: insurance.id,
      update: {
        insurers: [{
          id: editInsure.id,
          firstName: editInsure.firstName,
          lastName: editInsure.lastName,
          middleName: editInsure.middleName,
          birthday: moment(editInsure.birthday, 'DD-MM-YYYY').utc(true).toISOString()
        }],
      },
    }, dispatch)
    editItem({ firstName: '', lastName: '', birthday: '', middleName: '' })
  }

  const handleEditInsure = name => ({ target: { value } }) => {
    const newData = JSON.parse(JSON.stringify(editInsure));
    newData[name] = value;
    editItem(newData);
  }

  const handleChangeEditDate = name => ({ target: { value } }) => {
    const newData = JSON.parse(JSON.stringify(editInsure));
    let splitedDate = value.split('-');
    if (value.length > 7) {
      const mm = Number(splitedDate[1]) > 12 ? 12 : splitedDate[1];
      splitedDate[1] = mm;
      const mmDays = moment(`01-${mm}`, 'DD-MM').daysInMonth();
      if (Number(splitedDate[0]) > mmDays) {
        splitedDate[0] = mmDays
      }
      if (Number(splitedDate[2]) > moment().get('years')) {
        splitedDate[2] = moment().get('years')
      }
    }
    newData[name] = splitedDate.join('-');
    editItem(newData);
  }


  return (
    <React.Fragment>
      <p className={classes.orderTitle}>Застрахованные</p>
      {insurance.insurers.map(insure => (
        <div key={insure.id} className={editInsure.id === insure.id ? classes.orderFlexItem : classes.orderItem}>
          {editInsure.id === insure.id ? (
            <React.Fragment>
              <div className={classes.orederInputsWrap}>
              <div className={classes.orderAddPeopleItem}>
                  <label htmlFor="family-name">Фамилия</label>
                  <Input
                    id="family-name"
                    value={editInsure.lastName || insure.lastName}
                    onChange={handleEditInsure('lastName')}
                    placeholder="Фамилия"
                    autoComplete='last-name'
                  />
                </div>
                <div className={classes.orderAddPeopleItem}>
                  <label htmlFor="first-name">Имя</label>
                    <Input
                      id="first-name"
                      value={editInsure.firstName || insure.firstName}
                      onChange={handleEditInsure('firstName')}
                      placeholder="Имя"
                      autoComplete='name'
                    />
                </div>
                <div className={classes.orderAddPeopleItem}>
                  <label htmlFor="middle-name">Отчество</label>
                  <Input
                    id="middle-name"
                    value={editInsure.middleName || insure.middleName}
                    onChange={handleEditInsure('middleName')}
                    placeholder="Отчество"
                  />
                </div>
                <div className={classes.orderAddPeopleItem}>
                  <label htmlFor="birthday">Дата рождения</label>
                  <InputMask
                    mask="ДД-ММ-ГГГГ"
                    maskChar={null}
                    onChange={handleChangeEditDate('birthday')}
                    value={editInsure.birthday}
                    alwaysShowMask={false}
                    autoComplete="birth-date"
                    formatChars={{
                      "Д": "[0-9]",
                      "Г": "[0-9]",
                      "М": "[0-9]"
                    }}
                  >
                    {(props) => (<Input id="birthday" {...props} placeholder="ДД-ММ-ГГГГ" />)}
                  </InputMask>
                </div>
              </div>
              <div className={classes.orderItemEditActions}>
                <div className={classes.orderEditItem} onClick={onSaveInsure}><EditIcon /><p>Сохранить</p></div>
                <div className={classes.orderEditItem} onClick={deletItem(insure.id)}> <DeleteIcon /> <p>Удалить</p></div>
              </div>
            </React.Fragment>
          ) : (
              <React.Fragment>
                {/* <div className='insured-collapsed'> */}
                  <p className={classes.orderItemTitle}>
                    {insure.firstName} {insure.middleName} {insure.lastName}<span>({moment(insure.birthday).format('DD MMMM YYYY')})</span>
                  </p>
                  <div className={classes.orderItemActions}>
                    <div className={classes.orderEditItem} onClick={onEditInsure(insure)}><EditIcon /><p>Редактировать</p></div>
                    <div className={classes.orderEditItem} onClick={deletItem(insure.id)}> <DeleteIcon /> <p>Удалить</p></div>
                  </div>
                {/* </div> */}
              </React.Fragment>
            )}
        </div>
      ))}
      <form noValidate autoComplete="on">
      <div className={classes.orderAddPeople}>
      <div className={classes.orderAddPeopleItem}>
          <label htmlFor="family-name">Фамилия</label>
          <Input
            id="family-name"
            value={orderingData.lastName}
            onChange={handleChangeInput('lastName')}
            placeholder="Фамилия"
          />
        </div>
        <div className={classes.orderAddPeopleItem}>
          <label htmlFor="first-name">Имя</label>
          {/* <FormControl helperText="Some important text"> */}
                    {/* <InputLabel htmlFor="first-name">Name</InputLabel> */}
                    <Input
                      id="first-name"
                      value={orderingData.firstName}
                      onChange={handleChangeInput('firstName')}
                      placeholder="Имя"
                    />
                  {/* </FormControl> */}
                  {/* <TextField
          id="standard-helperText"
          label="Helper text"
          defaultValue="Default Value"
          helperText="Some important text"
        /> */}

        </div>
        <div className={classes.orderAddPeopleItem}>
          <label htmlFor="middle-name">Отчество</label>
          <Input
            id="middle-name"
            value={orderingData.middleName}
            onChange={handleChangeInput('middleName')}
            placeholder="Отчество"
          />
        </div>
        <div className={cs(classes.orderAddPeopleItemBirthday, classes.orderAddPeopleItem)}>
          <label htmlFor="birthday">Дата рождения</label>
          <InputMask
            mask="ДД-ММ-ГГГГ"
            maskChar={null}
            onChange={handleChangeDate('birthday')}
            value={orderingData.birthday}
            alwaysShowMask={false}
            formatChars={{
              "Д": "[0-9]",
              "Г": "[0-9]",
              "М": "[0-9]"
            }}
          >
            {(props) => (<Input id="birthday" {...props} placeholder="ДД-ММ-ГГГГ" />)}
          </InputMask>
        </div>
        </div>
      </form>
      <Button classes={{ root: classes.addPeopleButton }} onClick={onAddPeople}>Добавить человека</Button>
    </React.Fragment>
  )
}

export default Ordering;
